// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2so44","question":"styles_question__2DfSG","description":"styles_description__3iXy8"};